<template>
  <div class="message-text">
    {{ text }}
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  message: {
    type: Object,
    default: () => ({
      content: ''
    })
  }
})

const text = computed(() => props.message.content || '')
</script>

<style lang="scss" scoped>
.message-text {
  padding: 8px 12px;
  font-size: 14px;
  line-height: 20px;
  color: #323233;
  word-break: break-all;
}
</style>
